// extracted by mini-css-extract-plugin
export default {"wrapper":"VNeDx","content":"ILVfY","circle":"bTr7V","success":"B0VXM","error":"wOwms","icon":"yrVuw","title":"gY1Y9"};